import { Pipe, PipeTransform } from '@angular/core'
import { AppBasicItemResult } from '../../models/interfaces/app-basic-item-result.interface'

@Pipe({
   name: 'appStatutes',
   pure: true,
   standalone: true
})
export class AppStatutesPipe implements PipeTransform {
   transform(value: number | null | undefined, appStatutes: AppBasicItemResult[] | null | undefined): string {
      return appStatutes?.find((v) => v.id == value)?.description ?? '-'
   }
}
